module.exports = __webpack_public_path__ + "img/education.be8279f3.svg";